import React, {useMemo} from 'react';
import {assert} from 'assert-ts';
import {useParams} from 'react-router';
import {CodeListsGate} from 'services/codelists';
import {ThesaurusesGate} from 'services/thesaurus';
import {useAllThesaurusIds} from 'services/thesaurus/hooks/useAllThesaurusIds';
import {
  SceneExtensionsContext,
  useLinkedValueSearchSceneExtensionCore,
  useMultiThesaurusEditSceneExtensionCore,
  useSceneExtensionsContextProviderValue,
  useThesaurusEditSceneExtensionCore,
} from 'sceneExtensions';
import type {UpdateMetadataParamsContextType} from '../../types';
import {useMetadataCodelistIds} from '../../services/metadata';
import {useLinkedValueSearchPageConfig} from '../updateMetadata/hooks/useLinkedValueSearchPageConfig';
import {MergeWorkSceneCore} from './MergeWorkSceneCore';

export const MergeWorkScene = () => {
  const params = useParams();

  const workId = assert(
    params['targetId'],
    'MergeWorkScene: targetId parameter expected',
  );

  const thesaurusIds = useAllThesaurusIds();
  const paramsContext: UpdateMetadataParamsContextType = {
    workId,
    manifestationDesignator: undefined,
    mock: false,
  };

  const codelistIds = useMetadataCodelistIds();

  const linkedValueSearchPageConfig = useLinkedValueSearchPageConfig({
    id: paramsContext.workId,
  });

  const thesaurusEditExtension = useThesaurusEditSceneExtensionCore();
  const multiThesaurusEditExtension = useMultiThesaurusEditSceneExtensionCore();
  const linkedValueSearchExtension = useLinkedValueSearchSceneExtensionCore(
    {
      canToggleFullWidth: true,
    },
    linkedValueSearchPageConfig,
  );
  const extensions = useMemo(
    () => [
      thesaurusEditExtension,
      multiThesaurusEditExtension,
      linkedValueSearchExtension,
    ],
    [
      linkedValueSearchExtension,
      multiThesaurusEditExtension,
      thesaurusEditExtension,
    ],
  );
  const sceneExtensionContext =
    useSceneExtensionsContextProviderValue(extensions);

  return (
    <ThesaurusesGate thesauruses={thesaurusIds}>
      <CodeListsGate codeLists={codelistIds}>
        <SceneExtensionsContext.Provider value={sceneExtensionContext}>
          <MergeWorkSceneCore />
        </SceneExtensionsContext.Provider>
      </CodeListsGate>
    </ThesaurusesGate>
  );
};
